import { SiteLink as Link } from '../SiteLink';
import { TUTORIALS_PATH, sectionPath, tutorialPath } from '../../content';
import type { Tutorial, TutorialSection } from '../../content';

const SITE_URL = 'https://statio.dev';

/**
 * Tutorials > Section > Tutorial, visible and as BreadcrumbList data. The last
 * crumb is the page the reader is on, so it is text rather than a link.
 */
export function Breadcrumbs({ section, tutorial }: { section: TutorialSection; tutorial?: Tutorial }) {
  const trail = [
    { label: 'Tutorials', path: TUTORIALS_PATH },
    { label: section.label, path: sectionPath(section) },
    ...(tutorial ? [{ label: tutorial.title, path: tutorialPath(tutorial.slug) }] : []),
  ];
  const ld = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: trail.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.label,
      item: `${SITE_URL}${c.path}/`,
    })),
  };

  return (
    <nav className="tu-crumbs" aria-label="Breadcrumb">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }} />
      <ol>
        {trail.map((c, i) =>
          i === trail.length - 1 ? (
            <li key={c.path}>
              <span aria-current="page">{c.label}</span>
            </li>
          ) : (
            <li key={c.path}>
              <Link to={c.path}>{c.label}</Link>
            </li>
          ),
        )}
      </ol>
    </nav>
  );
}
